// © Microsoft Corporation. All rights reserved.

import { DesignSystem, isDarkMode } from "@microsoft/fast-components-styles-msft";

import { applyLocalizedProperty } from "@microsoft/fast-jss-utilities";
import { enums } from "../../../../utils/enums";

const sidePadding = "10px";

export const ProfileCardSuperAppStyles = (config: DesignSystem) => ({
    profileCardSuperAppContainer: {
        "-webkit-box-shadow": "none",
        "-moz-box-shadow": "none",
        "box-shadow": "none",
        background: "transparent",
        margin: "0",
        position: "static",
        padding: "17px 20px 0",
        width: "auto",
        "min-width": "calc(320px - 2 * " + sidePadding + ")",

        "& .cwt-avatar-container": {
            height: "64px",
            "& .cwt-avatar": {
                "min-width": "64px",
                "max-width": "64px",
                height: "64px"
            }
        },

        "& .cwt-user-info": {
            "& .cwt-user-header": {
                "& .cwt-name-title": {
                    width: "auto",
                    margin: "8px 0",
                    "& .cwt-name": {
                        "margin-top": "0",
                        "font-size": "26px",
                        color: "white",
                        "line-height": "31px",
                        "letter-spacing": applyLocalizedProperty("0.35px", "0", config.direction)
                    },
                    "&.cwt-name-title-self": {
                        "margin-top": "9px"
                    }
                }
            }
        },
        "& .cwt-action-panel": {
            "padding-bottom": "7px",
            border: "none",
            margin: "0 -18px",
            display: "flex",
            "justify-content": "center",
            "& .cwt-link": {
                "& .cwt-icon": {
                    color: "white",
                    "& .cwt-icon-label": {
                        color: "white"
                    }
                }
            },
            "& .cwt-other-profile-settings": {
                "justify-content": "center",
                "& .cwt-fast-button, .cwt-button-no-access": {
                    "box-shadow": "0px 0px 4px rgba(0, 0, 0, 0.04)",
                    background: isDarkMode(config) ? "#6794d7": "white",
                    color: isDarkMode(config) ? "#FFFFFF":"#3D6CDC"
                }
            }
        },

        ["&." + enums.responsiveLevels.L0]: {
            padding: "17px 20px 0",

            "& .cwt-avatar-container": {
                height: "72px",
                "& .cwt-avatar": {
                    "min-width": "72px",
                    "max-width": "72px",
                    height: "72px"
                }
            },

            "& .cwt-action-panel": {
                "justify-content": "flex-start",
                "& .cwt-other-profile-settings": {
                    "justify-content": "flex-start"
                }
            },

            "& .cwt-user-info": {
                "& .cwt-user-header": {
                    "& .cwt-name-title": {
                        width: "100%",
                        margin: "0 12px",
                        "& .cwt-name": {
                            "font-size": "22px",
                            "line-height": "26px"
                        }
                    }
                }
            }
        }
    }
});
